export function formatDate(date: number, options?: Intl.DateTimeFormatOptions): string {
    return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        ...options,
    }).format(date);
}